export default __webpack_public_path__ + "static/media/logo.0e12c2e9.png";